import { roundFCFA } from '@shared/utils/round';
import {
  ANCIENNETE_SEUIL_ANS,
  TAUX_PRIME_ANCIENNETE,
  TAUX_PRIME_ANCIENNETE_ANNUEL,
} from '@shared/constants/Taux';

const TAUX_INITIAL = TAUX_PRIME_ANCIENNETE;
const TAUX_ANNUEL = TAUX_PRIME_ANCIENNETE_ANNUEL;
const PLAFOND = 0.3;
const ANNEE_DECLENCHEMENT = ANCIENNETE_SEUIL_ANS;

/**
 * Barème conventionnel général : 2 % après 2 ans, puis +1 % par an (n % à n ans), plafonné à 30 %.
 * Conventions collectives de la base juridique (tronc commun A.30, Commerce, Bois, BTP…).
 */
export function tauxPrimeAnciennete(annees: number): number {
  const pleines = Math.floor(annees);
  if (pleines < ANNEE_DECLENCHEMENT) return 0;
  return Math.min(PLAFOND, TAUX_INITIAL + TAUX_ANNUEL * (pleines - ANNEE_DECLENCHEMENT));
}

export function anneesAnciennete(dateEmbauche: string, dateRef: Date = new Date()): number {
  const embauche = new Date(dateEmbauche);
  if (Number.isNaN(embauche.getTime())) return 0;
  const mois =
    (dateRef.getFullYear() - embauche.getFullYear()) * 12 +
    (dateRef.getMonth() - embauche.getMonth());
  return Math.floor(Math.max(0, mois) / 12);
}

export function calculerPrimeAnciennete(opts: {
  salaireBase: number;
  dateEmbauche: string;
  saisie?: number;
  dateRef?: Date;
}): number {
  if (opts.saisie !== undefined) return roundFCFA(opts.saisie);
  const annees = anneesAnciennete(opts.dateEmbauche, opts.dateRef);
  return roundFCFA(opts.salaireBase * tauxPrimeAnciennete(annees));
}
